module.exports = __webpack_public_path__ + "img/icon-success.541b8e93.svg";